import React from 'react';
import TextBox from '../../Basic/TextBox';
import DatePicker from '../../Enhanced/DatePicker';

const ContactPersonDOB = ({ name, disabled }) => {
    return (
        <div>
            <div className="row worksite_contact">
                <div className="col-sm-4">
                    <TextBox name={`${name}FirstName`} title="First name" disabled={disabled} />
                </div>
                <div className="col-sm-4">
                    <TextBox name={`${name}LastName`} title="Last name" disabled={disabled} />
                </div>
            </div>
            <div className="row worksite_contact">
                <div className="col-sm-4">
                    <DatePicker name={`${name}DOB`} title="Date of birth" disabled={disabled} />
                </div>
            </div>
        </div>
    );
};
ContactPersonDOB.propTypes = {
    name: React.PropTypes.string.isRequired,
    disabled: React.PropTypes.bool,
};
export default ContactPersonDOB;